import './mainevent/style';
import FormStructure from './mainevent/form_structure';

export default FormStructure;